// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9af65960","453":"8a4c86ca","455":"ed3b9cd6","977":"84d51038"}[chunkId] + ".chunk.js";
};